// Copyright (c) 2022 WiseTime. All rights reserved.

import { concat, Observable, of } from "rxjs"
import { Action } from "redux"
import { t } from "@lingui/macro"
import { catchError, filter, mergeMap } from "rxjs/operators"
import { create } from "@bufbuild/protobuf"
import * as Actions from "../actions"
import * as Slice from "../slices/stats"
import { showSnackBar } from "../../snackbar/actions"
import { executorMutation, Init, postExpectationService } from "../../../app/rpc"
import {
  CreateLeaveRequestSchema,
  Leave,
} from "../../../generated/legebill/site/postexpectation/v4/post_expectation_pb"

type CreateLeaveRpc = (request: Init<typeof CreateLeaveRequestSchema>) => Observable<Leave>

export const createLeave = (createLeaveRpc: CreateLeaveRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.createLeave.match),
      mergeMap(action => createLeaveRpc(action.payload)
        .pipe(
          mergeMap(response => concat(
            of(Slice.addLeave(response)),
            of(Actions.refreshMemberExpectations({
              siteId: action.payload.siteId,
              membershipId: action.payload.membershipId,
              startDate: action.payload.date,
              endDate: action.payload.date,
            })),
          )),
          catchError(() => of(showSnackBar({
            message: t({ id: "msg_create_leave_failed", message: "Failed to add leave. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com." }),
            messageType: "ERROR",
          }))),
        )
      ),
    )

const createLeaveRpc = (request: Init<typeof CreateLeaveRequestSchema>): Observable<Leave> =>
  executorMutation(() => postExpectationService.createLeave(create(CreateLeaveRequestSchema, request)))

export default createLeave(createLeaveRpc)
